import { createActionGroup, props } from '@ngrx/store';

export const GlobalNavActions = createActionGroup({
  source: 'Global Nav',
  events: {
    'Nav Item Tapped': props<{
      /** The tapped tab's `APP_ROUTES` segment — 'home', 'to-dos', … */
      featureKey: string;
      /** Whether the tab was already the active one when it was tapped, i.e. a re-tap. */
      wasSelected: boolean;
    }>(),
  },
});
